"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'webhook.cronIntervals.every_5_minutes': 'Ogni 5 minuti',
    'webhook.cronIntervals.every_10_minutes': 'Ogni 10 minuti',
    'webhook.cronIntervals.every_15_minutes': 'Ogni 15 minuti',
    'webhook.cronIntervals.every_30_minutes': 'Ogni 30 minuti',
    'webhook.cronIntervals.every_45_minutes': 'Ogni 45 minuti',
    'webhook.cronIntervals.every_hour': 'Ogni ora',
    'webhook.cronIntervals.every_2_hours': 'Ogni 2 ore',
    'webhook.cronIntervals.every_6_hours': 'Ogni 6 ore',
    'webhook.cronIntervals.every_12_hours': 'Ogni 12 ore',
    'webhook.cronIntervals.daily': 'Giornaliero (mezzanotte)',
    'webhook.cronIntervals.weekly': 'Settimanale (domenica mezzanotte)',
};
